module.exports = __webpack_public_path__ + "media/images/leads_generation/decision-makers-info-4dc5eca6497ba88134673e0852f7f81c.svg";